export const DISCIPLINES = [
  {
    name: 'Introdução à Segurança e à Privacidade',
    cred: 1,
    work: 16
  },
  {
    name: 'Redes e Computação em Nuvem',
    cred: 2,
    work: 32
  },
  {
    name: 'Metodologia de Pesquisa Científica',
    cred: 1,
    work: 16
  },
  {
    name: 'Desenvolvimento Seguro de Software',
    cred: 1,
    work: 16
  },
  {
    name: 'Aprendizado de Máquina',
    cred: 2,
    work: 32
  },
  {
    name: 'Segurança da Informação e Criptografia',
    cred: 1,
    work: 16
  },
  {
    name: 'Palestras Técnicas em Segurança e Privacidade',
    cred: 2,
    work: 32
  },
  {
    name: 'Segurança em Redes de Computadores',
    cred: 1,
    work: 16
  },
  {
    name: 'Segurança em Aplicações Web',
    cred: 1,
    work: 16
  },
  {
    name: 'Segurança em Aplicações Móveis e IoT',
    cred: 1,
    work: 16
  },
  {
    name: 'Certificações e Entidades Certificadoras',
    cred: 1,
    work: 16
  },
  {
    name: 'Leis e Regulamentações',
    cred: 1,
    work: 16
  },
  {
    name: 'Algoritmos Distribuídos e Blockchain',
    cred: 2,
    work: 32
  },
  {
    name: 'Segurança e Privacidade de Dados',
    cred: 2,
    work: 32
  },
  {
    name: 'Vulnerabilidade em Sistemas Operacionais (Hardening)',
    cred: 1,
    work: 16
  },
  {
    name: 'Análise de Malware',
    cred: 1,
    work: 16
  },
  {
    name: 'Aprendizagem de Máquina Aplicada à Segurança',
    cred: 1,
    work: 16
  },
  {
    name: 'Segurança em Nuvens Computacionais',
    cred: 1,
    work: 16
  },
  {
    name: 'Segurança Cibernética e Processamento de Imagem',
    cred: 1,
    work: 16
  },
  {
    name: 'Computação Forense',
    cred: 1,
    work: 16
  },
  {
    name: 'TOTAL',
    cred: 25,
    work: 400
  }
]
